__turbopack_context__.v({
  "content_row_description": "V4XHHG_content_row_description",
  "content_row_title": "V4XHHG_content_row_title",
  "content_row_title__logo": "V4XHHG_content_row_title__logo",
  "content_row_title__logo__wrapper": "V4XHHG_content_row_title__logo__wrapper",
  "content_row_title_description": "V4XHHG_content_row_title_description",
});
